/**
 * Countdown Timer Script
 * ----------------------------------------------
 * Key Features:
 * - Converts a specified end date (in ISO format) into a countdown timer.
 * - Supports multiple timers on the same page with individual end times.
 * - Updates the timers every second and stops when the countdown reaches zero.
 * - Handles time zone differences and ensures consistent behavior across browsers.
 *
 * Expected Markup:
 * Each countdown timer should have the following structure:
 *
 * <span class="js-countdown-timer" data-countdown-end="2030-08-29 18:00:00"></span>
 *
 *
 * Notes:
 * - The `data-countdown-end` attribute should contain the end date in the format: YYYY-MM-DD HH:mm:ss.
 * - This script uses `toLocaleString` with a specific time zone to ensure consistency.
 *
 */
(function () {
  /**
   * Converts a date string to a timestamp compatible with iOS.
   * @param {string} date - The date string in the format "YYYY-MM-DD HH:mm:ss".
   * @returns {number} - The timestamp in milliseconds.
   */
  function convertDateForIos(date) {
    const [year, month, day, hour, minute, second] = date.split(/[- :]/);
    return new Date(year, month - 1, day, hour, minute, second).getTime();
  }

  /**
   * Formats the remaining time as a countdown string.
   * @param {number} remainingTime - The remaining time in milliseconds.
   * @returns {string} - Formatted time as "DD:HH:MM:SS".
   */
  function formatCountdown(remainingTime) {
    const day = Math.floor(remainingTime / dayMs)
      .toString()
      .padStart(2, '0');
    const hour = Math.floor((remainingTime % dayMs) / hourMs)
      .toString()
      .padStart(2, '0');
    const minute = Math.floor((remainingTime % hourMs) / minuteMs)
      .toString()
      .padStart(2, '0');
    const second = Math.floor((remainingTime % minuteMs) / secondMs)
      .toString()
      .padStart(2, '0');

    if (day === '00') {
      return `<b class="countdown-endsup-today">${hour}:${minute}:${second}</b>`;
    }
    return `${day}:${hour}:${minute}:${second}`;
  }

  const secondMs = 1000,
    minuteMs = secondMs * 60,
    hourMs = minuteMs * 60,
    dayMs = hourMs * 24;
  // Initialize each countdown timer
  const countdownElements = document.querySelectorAll('.js-countdown-timer');

  countdownElements.forEach((timer) => {
    const endDate = timer.getAttribute('data-countdown-end');
    if (!endDate) return; // Skip if no end date is provided

    const countdownTarget = convertDateForIos(endDate);

    const intervalId = setInterval(() => {
      const now = new Date().toLocaleString('en-US', { timeZone: 'Europe/London' });
      const currentTime = new Date(now).getTime();
      const remainingTime = countdownTarget - currentTime;

      if (remainingTime < 0) {
        clearInterval(intervalId);
        timer.innerHTML = `<span class="countdown-ended">00:00</span>`;
        return;
      }

      timer.innerHTML = formatCountdown(remainingTime);
    }, 1000);
  });
})();
